export class CreateTaskResponseDto {
    result: boolean;

    constructor(result: boolean) {

        this.result = result;
    }
}
